import Elearningmurid from '../../../views/Kurikulum/Elearning/elearningmurid.view';

export default Elearningmurid;
